<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" :inline="true" label-width="77px"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
            <el-form-item label="操作人员:">
              <el-input v-model="table.where.username" placeholder="请输入操作人员" clearable/>
            </el-form-item>
            <el-form-item label="操作日期:">
                <el-date-picker
                  v-model="where.create_time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changetime"
                  >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search">查询
                </el-button>
                <el-button @click="reload">重置</el-button>
              </el-form-item>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" height="calc(100vh - 260px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
          <!-- <el-table-column prop="title" label="日志标题" align="center" show-overflow-tooltip min-width="100"/> -->
          <el-table-column prop="username" label="操作人员" align="center" show-overflow-tooltip min-width="100"/>
          
          <el-table-column prop="create_time" label="操作日期" align="center" min-width="160" show-overflow-tooltip>
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          
          <el-table-column prop="ip" label="IP地址" align="center" show-overflow-tooltip min-width="130"/>
          
          <el-table-column prop="type" label="操作记录" align="center" min-width="110" show-overflow-tooltip>
            <template slot-scope="{row}">
              {{row.module}}{{row.action}}{{row.url}}{{row.param}}
            </template>
          </el-table-column>
          
          <!-- <el-table-column label="操作" width="90px" align="center" :resizable="false" fixed="right">
            <template slot-scope="{row}">
              <el-link @click="view(row)" icon="el-icon-view" type="primary" :underline="false">详情</el-link>
            </template>
          </el-table-column>
          -->
        </template>
      </ele-data-table>
    </el-card>
    <!-- 详情弹窗 -->
    <el-dialog title="详情" :visible.sync="showView" width="600px" :destroy-on-close="true" :lock-scroll="false">
      <el-form label-width="82px" size="mini" class="ele-form-detail">
        <el-row :gutter="15">
          <el-col :sm="12">
            <el-form-item label="操作账号:" prop="username">
              <div class="ele-text-secondary">{{ viewForm.username }}</div>
            </el-form-item>
            <el-form-item label="请求方式:" prop="method">
              <div class="ele-text-secondary">{{ viewForm.method }}</div>
            </el-form-item>
            <el-form-item label="操作方法:" prop="action">
              <div class="ele-text-secondary">{{ viewForm.action }}</div>
            </el-form-item>
            <el-form-item label="操作类型:" prop="type">
              <el-tag :type="['', 'success'][viewForm.type]" size="mini">
                {{ ['登录系统','注销系统', '操作日志'][viewForm.type] }}
              </el-tag>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="日志标题:" prop="title">
              <div class="ele-text-secondary">{{ viewForm.title }}</div>
            </el-form-item>
            <el-form-item label="操作模块:" prop="module">
              <div class="ele-text-secondary">{{ viewForm.module }}</div>
            </el-form-item>
             <el-form-item label="操作IP:" prop="ip">
              <div class="ele-text-secondary">{{ viewForm.ip }}</div>
            </el-form-item>
            <el-form-item label="操作时间:" prop="create_time">
              <div class="ele-text-secondary">{{ viewForm.create_time | toDateString }}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="margin: 12px 0;">
          <el-divider/>
        </div>
        <el-form-item label="操作URL:" prop="url">
          <div class="ele-text-secondary">{{ viewForm.url }}</div>
        </el-form-item>
        <el-form-item label="请求参数:" prop="operParam">
          <div class="ele-text-secondary">{{ viewForm.param }}</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showView=false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SysOperRecord",
  data() {
    return {
        where:{
            
        },
      table: {url: '/actionlog/index', where: {}},  // 表格配置
      showView: false,  // 是否显示查看弹窗
      viewForm: {},  // 表单数据
      daterange: '',  // 筛选日期范围
      pickerOptions: {  // 日期时间选择器快捷项
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  methods: {
      /* 选择时间*/
      changetime(e){
          var time = [];
          time[0] = this.time(e[0]);
          time[1] = this.time(e[1]);
          this.table.where.create_time = time;
       },
      time(dealdate){
            const date = new Date(dealdate)
           const year = date.getFullYear()   
           let month = date.getMonth() + 1
           month = month<10?"0"+month:month   
           let day = date.getDate()
           day = day<10?"0"+day:day        
           let hour = date.getHours()     
           hour = hour<10?"0"+hour:hour          
           let minute = date.getMinutes() 
           minute = minute<10?"0"+minute:minute  
           let second = date.getSeconds()
           second = second<10?"0"+second:second 
           return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
      },
    /* 详情 */
    view(row) {
      this.viewForm = Object.assign({}, row);
      this.showView = true;
    },
    /* 日期选择改变回调 */
    onDateRangeChoose() {
      if (this.daterange) {
        this.table.where.createTimeStart = this.daterange[0];
        this.table.where.createTimeEnd = this.daterange[1];
      } else {
        this.table.where.createTimeStart = null;
        this.table.where.createTimeEnd = null;
      }
    },
    /* 刷新 */
    reload() {
      this.daterange = null;
      this.table.where = {};
      this.$refs.table.reload();
    }
  }
}
</script>

<style scoped>

</style>